// extracted by mini-css-extract-plugin
module.exports = {"container":"CalendarItem_container__3Oufz","item":"CalendarItem_item__1DtYs","date":"CalendarItem_date__3eHHf","odd":"CalendarItem_odd__XX0MP","view":"CalendarItem_view__1Bj1D"};